import { render } from "./ModalQuestionario.vue?vue&type=template&id=b9051dd0"
import script from "./ModalQuestionario.vue?vue&type=script&lang=js"
export * from "./ModalQuestionario.vue?vue&type=script&lang=js"

import "./ModalQuestionario.vue?vue&type=style&index=0&id=b9051dd0&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__